export default __webpack_public_path__ + "static/media/affirm.06ae083f.svg";